import {
  Box,
  Divider,
  Typography,
} from '@mui/material';
import CustodianBillingInfo from '../../../../Models/custodian/custodian-billingInfo';
import BillingInfoInvoicingDetails from './BillingInfoInvoicingDetails';
import BillingInfoFeesDetails from './BillingInfoFeesDetails';
import BillingInfoPayeeDetails from './BillingInfoPayeeDetails';
import useFetchPaymentMethods from '../../../../hooks/Locations/useFetchPaymentMethods';
import { useState, useEffect, useMemo } from 'react';
import useBillingInfoForm from '../../../../hooks/Locations/addLocation/useBillingInfoForm';
import useFetchStates from '../../../../hooks/Locations/useFetchStates';
import { FormikProps } from 'formik';
import BillingInfo from '../../../AddLocation/Components/BillingInfo';
import EntityCustodianDetailsViewModel from '../../../../Models/custodian/entity-custodian-details-viewmodel';
import { horizontalLine, subPanelHeader } from '../../../../assets/styles/appStyles';

export default function BillingInfoDetails({
  custodian,
}: {
  custodian?: EntityCustodianDetailsViewModel;
}) {
  const [editModes, setEditMode] = useState<boolean>(false);
  const [currentBillingInfo, setCurrentBillingInfo] = useState<
    CustodianBillingInfo | undefined
  >(custodian?.billingInformation);

  const { paymentMethods } = useFetchPaymentMethods();

  const { states } = useFetchStates();

  const { billingInfoForm } = useBillingInfoForm({
    states: states,
  });

  useEffect(() => {
    setCurrentBillingInfo(custodian?.billingInformation)
  }, []);

  return (
    <>{!editModes ? (
      <Box mt={2}>
        <Typography sx={subPanelHeader}>Billing Details</Typography>
            <BillingInfoInvoicingDetails
              paymentMethods={paymentMethods}
              billingInfoInvoicingPaymentMethods={
                custodian?.billingInformation?.billingInfoInvoicingPaymentMethods ?? []
              }
              invoiceBeforeRecords={
                custodian?.billingInformation?.invoiceBeforeRecords ?? false
              }
            />
          <Divider sx={horizontalLine} />
            <BillingInfoFeesDetails
              paymentMethods={paymentMethods}
              billingInfoProcessingFeesMethods={
                custodian?.billingInformation?.billingInfoProcessingFeesMethods ?? []
              }
              processingFeesAuthorization={
                custodian?.billingInformation?.processingFeesAuthorization ?? 0
              }
              processingFeesSubpoena={
                custodian?.billingInformation?.processingFeesSubpoena ?? 0
              }
              initialProcessingFee={
                custodian?.billingInformation?.initialProcessingFee ?? false
              }
              initialProcessingFeeNotes={
                custodian?.billingInformation?.initialProcessingFeeNotes ?? ''
              }
            />
          <Divider sx={horizontalLine} />
            <BillingInfoPayeeDetails
              payeeAddress={custodian?.billingInformation?.payeeAddress ?? ''}
              payeeCity={custodian?.billingInformation?.payeeCity ?? ''}
              payeeContact={custodian?.billingInformation?.payeeContact ?? ''}
              payeeName={custodian?.billingInformation?.payeeName ?? ''}
              payeePostCode={custodian?.billingInformation?.payeePostCode ?? ''}
              payeeStateName={custodian?.billingInformation?.payeeStateName ?? ''}
            />
      </Box>
    ) : (
      <BillingInfo
        form={billingInfoForm}
        states={states}
        paymentMethods={paymentMethods}
      />
    )}
    </>
  );
}
